<script lang="ts">
    import { twMerge } from 'tailwind-merge';

    export let name: string;
    export let type: 'outline' | 'legacy' | 'fill' | 'illust' = 'outline';

    const outlineIcons = import.meta.glob('./outline-svgs/*.svg', {
        eager: true,
        query: '?raw',
        import: 'default',
    }) as Record<string, string>;

    const fillIcons = import.meta.glob('./fill-svgs/*.svg', {
        eager: true,
        query: '?raw',
        import: 'default',
    }) as Record<string, string>;

    const legacyIcons = import.meta.glob('./legacy-svgs/*.svg', {
        eager: true,
        query: '?raw',
        import: 'default',
    }) as Record<string, string>;

    const illustIcons = import.meta.glob('./illust-svgs/*.svg', {
        eager: true,
        query: '?raw',
        import: 'default',
    }) as Record<string, string>;

    const iconMap = {
        outline: { icons: outlineIcons, path: './outline-svgs' },
        fill: { icons: fillIcons, path: './fill-svgs' },
        legacy: { icons: legacyIcons, path: './legacy-svgs' },
        illust: { icons: illustIcons, path: './illust-svgs' },
    };

    $: icons = iconMap[type].icons;
    $: iconPath = `${iconMap[type].path}/${name}.svg`;
    $: rawIconContent = icons[iconPath] as string | undefined;
</script>

<span class={twMerge('inline-flex h-4 w-4', $$restProps.class)}>
    {#if rawIconContent}
        {@const iconContent = rawIconContent.replace(/(<svg[^>]*)\s+width="[^"]*"([^>]*)/g, '$1$2').replace(/(<svg[^>]*)\s+height="[^"]*"([^>]*)/g, '$1$2')}
        {@html iconContent}
    {:else}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none">
            <rect x="1" y="1" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>
    {/if}
</span>

<!--
@component AllibeeIcon
동적으로 SVG 아이콘을 로드하는 컴포넌트입니다.

## 사용법
```svelte
<AllibeeIcon name="home" type="outline" class="h-6 w-6 text-blue-500" />
<AllibeeIcon name="home" type="fill" class="h-6 w-6 text-blue-500" />
<AllibeeIcon name="add" type="legacy" class="h-6 w-6 text-blue-500" />
<AllibeeIcon name="empty" type="illust" class="h-24 w-24" />
```

## Props
- `name` (required): 아이콘 이름 (해당 타입 폴더에 있는 파일명)
- `type`: 아이콘 타입 ('outline' | 'fill' | 'legacy' | 'illust', 기본값: 'outline')
- `class`: Tailwind CSS 클래스 (기본값: 'h-4 w-4 text-gray-900')

## 특징
- `outline-svgs/`, `fill-svgs/`, `legacy-svgs/`, `illust-svgs/` 폴더의 모든 SVG 파일을 자동으로 인식
- SVG의 고정 크기를 제거하여 유연한 크기 조절 가능
- `currentColor`를 사용하여 색상 조절 가능
- 존재하지 않는 아이콘의 경우 테두리가 있는 네모 표시

## 예시
```svelte
<AllibeeIcon name="home" type="outline" class="h-4 w-4" />
<AllibeeIcon name="home" type="fill" class="h-6 w-6" />
<AllibeeIcon name="add" type="legacy" class="h-8 w-8" />
<AllibeeIcon name="empty" type="illust" class="h-24 w-24" />

<AllibeeIcon name="home" type="outline" class="h-6 w-6 text-blue-500" />
<AllibeeIcon name="home" type="fill" class="h-6 w-6 text-red-500" />

<AllibeeIcon name="delete" type="legacy" class="h-5 w-5 cursor-pointer text-gray-700 hover:text-red-600" />
``` -->
